/** @format */

import {LastCheckType, SensorGroupCollection} from '../types';
import {getPerCampaignFound} from './getPerCampaignFound';

const mapSensorGroupCollection = (
  checks: ReadonlyArray<LastCheckType>,
  campaignId?: string,
): SensorGroupCollection => {
  const collection: SensorGroupCollection = {};
  checks.forEach(check => {
    const found = campaignId ? getPerCampaignFound(check, campaignId) : check.found;
    if (found <= 0) return;
    collection[check.sensor.name] = (collection[check.sensor.name] || 0) + found;
  });

  return collection;
};

export {mapSensorGroupCollection};
